import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sweepstakes-ssn.magic.css.js';
import script from './sweepstakes-ssn.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sweepstakes-ssn",attrs:{"part":"sweepstakes-ssn"}},[_c('magic-ui-text',{staticClass:"sweepstakes-ssn__title",attrs:{"part":"sweepstakes-ssn__title","content":_vm.$t('sweepstakes-ssn.title')}}),_vm._v(" "),_c('div',{staticClass:"sweepstakes-ssn__info",attrs:{"part":"sweepstakes-ssn__info"}},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"sweepstakes-ssn__input-area",attrs:{"part":"sweepstakes-ssn__input-area"}},[_c('magic-ui-text',{staticClass:"sweepstakes-ssn__label",attrs:{"part":"sweepstakes-ssn__label","content":_vm.$t('sweepstakes-ssn.label')}}),_vm._v(" "),_c('magic-ui-form-field',{staticClass:"sweepstakes-ssn__input",attrs:{"disable-autoscroll":"","part":"sweepstakes-ssn__input","has-success":!!_vm.taxId && !_vm.$v.taxId.$invalid,"value":(_vm.$v.taxId.$model)},on:{"input":function($event){return _vm.$set(_vm.$v.taxId, "$model", $event.detail[0])}}},[_c('magic-ui-code-entry',{attrs:{"disable-autoscroll":"","length":_vm.codeLength,"error":_vm.showSsnError && _vm.$t('sweepstakes-ssn.update-error'),"value":(_vm.$v.taxId.$model)},on:{"change":function($event){return _vm.$set(_vm.$v.taxId, "$model", $event.detail[0])}}})],1)],1),_vm._v(" "),_c('magic-ui-button',{staticClass:"sweepstakes-ssn__submit",attrs:{"part":"sweepstakes-ssn__submit","variant":"primary","large":"","no-margin":"","disabled":_vm.$v.taxId.$invalid,"loading":_vm.ssnLoading},domProps:{"innerHTML":_vm._s(_vm.$t('sweepstakes-ssn.submit'))},on:{"click":_vm.onSsnUpdate}})],1),_vm._v(" "),(_vm.showScan)?_c('div',{staticClass:"sweepstakes-scan",attrs:{"part":"sweepstakes-scan"}},[_c('magic-ui-text',{staticClass:"sweepstakes-scan__text",attrs:{"tag":"p","part":"sweepstakes-scan__text","content":_vm.$t('sweepstakes-ssn.scan.label')}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"sweepstakes-scan__submit",attrs:{"no-margin":"","hollow":"","large":"","part":"sweepstakes-scan__submit","data-v-test-id":"ssn-scan-button","loading":_vm.scanLoading,"disabled":_vm.scanDisabled},domProps:{"innerHTML":_vm._s(_vm.$t('sweepstakes-ssn.scan.button'))},on:{"click":_vm.onScanClick}})],1):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-74859625_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-74859625";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
